import React from "react";
import { ShieldAlert, Radio, HeartPulse, Phone, DoorOpen, BookOpen } from "lucide-react";

const GOLD = "#c9a24b";

const CHAPTERS = [
  { key: "impact", label: "Impact · 81st Floor", icon: ShieldAlert },
  { key: "rescue", label: "The Rescue · Acoustic Pull", icon: Radio },
  { key: "sky44", label: "44th · Sky Lobby", icon: HeartPulse },
  { key: "call31", label: "31st · The 9-1-1 Calls", icon: Phone },
  { key: "street", label: "Street Level", icon: DoorOpen },
];

// Guided-Study chapter rail — jump straight to any beat.
export default function StudyChapters({ current, onJump }) {
  return (
    <div
      data-testid="study-chapters"
      className="hud-panel"
      style={{ padding: "12px 12px 10px", borderRadius: 8, width: 208, pointerEvents: "auto" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 9 }}>
        <BookOpen size={13} color={GOLD} />
        <span style={{ fontSize: 9.5, letterSpacing: "0.2em", textTransform: "uppercase", color: GOLD }}>Chapters</span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {CHAPTERS.map((c) => {
          const active = current === c.key;
          return (
            <button
              key={c.key}
              data-testid={`study-chapter-${c.key}`}
              onClick={() => onJump(c.key)}
              style={{
                display: "flex", alignItems: "center", gap: 9, padding: "8px 10px", borderRadius: 5, cursor: "pointer",
                textAlign: "left", width: "100%", transition: "all 0.2s ease",
                background: active ? "rgba(201,162,75,0.16)" : "rgba(255,255,255,0.03)",
                border: `1px solid ${active ? GOLD : "rgba(201,162,75,0.2)"}`,
                color: active ? "#f2e6c8" : "#c2c6cf",
              }}
            >
              <c.icon size={13} color={active ? GOLD : "#9aa0ac"} />
              <span className="font-serif-q" style={{ fontSize: 12.5, fontStyle: "italic" }}>{c.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
